var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards",class:_vm.layout ? _vm.cardsLayout : ''},_vm._l((_vm.content),function(card){return _c('Card',{key:card.id,attrs:{"layout":_vm.layout,"content":card}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }